document.addEventListener('click', function(e) {
  var link = e.target.closest('.js-language-switcher .language-switch');
  if (link) {
    e.preventDefault();
    var d = new Date();
    d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
    document.cookie = 'language_preference=manual; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
    var url = new URL(link.href);
    url.searchParams.set('lp', 'manual');
    window.location.href = url.toString();
  }
});
